import { FC, useEffect, useState } from 'react';
import { useIntl } from 'react-intl';

import { CLUSTER, SUPPORT_EMAIL } from '@/shared/config';

import { i18n } from '../config/i18n';

import styles from './SupportFallback.module.scss';

export const SupportFallback: FC = () => {
  const { formatMessage } = useIntl();

  const [isChatLoaded, setIsChatLoaded] = useState(false);
  const [showFallback, setShowFallback] = useState(false);
  const [isPopupOpen, setIsPopupOpen] = useState(false);

  const isRu = CLUSTER === 'ru';

  useEffect(() => {
    const checkChatWidget = () => {
      const chatWidget = document.querySelector(
        'iframe[id*="hubspot"], [id*="hubspot-messages-iframe-container"], iframe[id*="happydesk"], iframe[src*="happydesk"], [class*="happydesk"]',
      );

      if (chatWidget) {
        setIsChatLoaded(true);
        setShowFallback(false);
      }
    };

    checkChatWidget();

    const interval = setInterval(checkChatWidget, 1000);

    const timeout = setTimeout(() => {
      if (!isChatLoaded) {
        setShowFallback(true);
      }
      clearInterval(interval);
    }, 5000);

    return () => {
      clearTimeout(timeout);
      clearInterval(interval);
    };
  }, [isChatLoaded]);

  if (!showFallback || !isRu) {
    return null;
  }

  return (
    <>
      <button
        data-component="open-support-button"
        className={styles.supportButton}
        onClick={() => setIsPopupOpen(true)}
        aria-label={formatMessage({
          id: 'supportFallback.ariaLabelOpen',
          defaultMessage: 'Customer Support',
        })}
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z"
            fill="currentColor"
          />
        </svg>
      </button>

      {isPopupOpen && (
        <>
          <div
            className={styles.overlay}
            onClick={() => setIsPopupOpen(false)}
          />
          <div className={styles.popup}>
            <button
              className={styles.closeButton}
              onClick={() => setIsPopupOpen(false)}
              aria-label={formatMessage({
                id: 'global.close',
                defaultMessage: 'Close',
              })}
            >
              ×
            </button>

            <h3 className={styles.title}>{formatMessage(i18n.supportTitle)}</h3>

            <div className={styles.content}>
              <div className={styles.contactItem}>
                <span className={styles.label}>
                  {formatMessage(i18n.emailLabel)}
                </span>
                <a href={`mailto:${SUPPORT_EMAIL}`} className={styles.link}>
                  {SUPPORT_EMAIL}
                </a>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};
